
import axios from "axios";
import { Auth } from "aws-amplify";

class Endpoint {
	constructor() {
		this.BackendEndBase = process.env.REACT_APP_BACKEND_API;
	}
}

export const Endpoints =  (new Endpoint());

class API {
    constructor() {
        this.head = async (endpoint, header = {}, config = {}) => {
            const session = await Auth.currentSession();
            const token = session.getIdToken().getJwtToken();
            return axios.head(
                endpoint,
                {
                    headers: {
                        Authorization: token,
                        "Content-Type": "application/json",
                        ...header,
                    },
                    ...config,
                },
            );
        };

        this.get = async (endpoint, header = {}, config = {}) => {
            const session = await Auth.currentSession();
            const token = session.getIdToken().getJwtToken();
            return axios.get(
                endpoint,
                {
                    headers: {
                        Authorization: token,
                        "Content-Type": "application/json",
                        ...header,
                    },
                    ...config,
                },
            );
        };

        this.post = async (endpoint, data, header = {}, config = {}) => {
            const session = await Auth.currentSession();
            const token = session.getIdToken().getJwtToken();
            return axios.post(endpoint, data, {
                headers: {
                    Authorization: token,
                    "Content-Type": "application/json",
                    ...header,
                },
                ...config,
            });
        };

        this.postAnonymous = async (endpoint, data, header = {}, config = {}) => {
            return axios.post(endpoint, data, {
                headers: {
                    "Content-Type": "application/json",
                    ...header,
                },
                ...config,
            });
        };

        this.put = async (endpoint, data, header = {}, config = {}) => {
            const session = await Auth.currentSession();
            const token = session.getIdToken().getJwtToken();
            return axios.put(endpoint, data, {
                headers: {
                    Authorization: token,
                    "Content-Type": "application/json",
                    ...header,
                },
                ...config,
            });
        };

        this.delete = async (endpoint, header = {}, config = {}) => {
            const session = await Auth.currentSession();
            const token = session.getIdToken().getJwtToken();
            return axios.delete(endpoint, {
                headers: {
                    Authorization: token,
                    "Content-Type": "application/json",
                    ...header,
                },
                ...config,
            });
        };
    }
}

export default API;
